import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from './core/config/auth.config';
import { AuthStorageKey } from './core/auth';

export function initAuth(oauthService: OAuthService) {
  return async (): Promise<void> => {
    // Set storage to localStorage
    oauthService.setStorage(localStorage);

    // Configure OAuth service
    oauthService.configure(authConfig);

    // Setup automatic silent refresh
    oauthService.setupAutomaticSilentRefresh();

    try {
      // Load discovery document and try to login
      await oauthService.loadDiscoveryDocumentAndTryLogin({
        onTokenReceived: () => {
          const stored: string | null = sessionStorage.getItem(AuthStorageKey.RETURN_URL);
          if (stored) {
            sessionStorage.removeItem(AuthStorageKey.RETURN_URL);
            window.location.replace(stored);
          }
        },
        disableOAuth2StateCheck: false,
        disableNonceCheck: false,
      });
    } catch (error) {
      console.error('Auth initialization failed:', error);
    }
  };
}
